import { apiFetch } from './api';

const API_URL = import.meta.env.VITE_API_URL || '';

/** `duvida` só chega pelo Brik AI; a caixinha oferece os outros quatro. */
export type TipoSugestao = 'sugestao' | 'melhoria' | 'critica' | 'elogio' | 'duvida';

/** Por onde chegou: a caixinha da sidebar ou o cartão "Avisar a equipe Brik" do Brik AI. */
export type OrigemSugestao = 'caixinha' | 'brik_ai';

export const TIPOS_SUGESTAO: { valor: TipoSugestao; rotulo: string }[] = [
    { valor: 'sugestao', rotulo: 'Sugestão' },
    { valor: 'melhoria', rotulo: 'Melhoria' },
    { valor: 'critica', rotulo: 'Crítica' },
    { valor: 'elogio', rotulo: 'Elogio' },
];

/** Os da caixinha mais a Dúvida do Brik AI: é o que a lista de Sistema › Sugestões filtra. */
export const TIPOS_NA_LISTA: { valor: TipoSugestao; rotulo: string }[] = [
    ...TIPOS_SUGESTAO,
    { valor: 'duvida', rotulo: 'Dúvida' },
];

export const rotuloTipoSugestao = (tipo: string) =>
    TIPOS_NA_LISTA.find(t => t.valor === tipo)?.rotulo ?? tipo;

export const ORIGENS_SUGESTAO: { valor: OrigemSugestao; rotulo: string }[] = [
    { valor: 'caixinha', rotulo: 'Caixinha' },
    { valor: 'brik_ai', rotulo: 'Brik AI' },
];

/** Uma linha de Sistema › Sugestões. */
export interface SugestaoSistema {
    id: number;
    tipo: TipoSugestao;
    texto: string;
    tela?: string | null;
    criadaEm: string;
    lidaEm?: string | null;
    empresaId: number;
    empresaNome: string;
    usuarioId: number;
    usuarioNome: string;
    usuarioEmail: string;
    origem: OrigemSugestao;
    /** Pelo Brik AI: a mensagem da pergunta, que abre a conversa em Sistema › Assistente. */
    assistenteMensagemId?: number | null;
    /** Pelo Brik AI: a pergunta como a pessoa escreveu. */
    pergunta?: string | null;
    /** Pelo Brik AI: o que ele respondeu. */
    resposta?: string | null;
}

interface ApiResponse<T> {
    sucesso: boolean;
    mensagem: string;
    dados: T;
}

/** A API devolve `{ sucesso, mensagem }` também no 400; o resto (500, rede) vira erro. */
const ler = async <T,>(r: Response): Promise<ApiResponse<T>> => {
    if (r.ok || r.status === 400) return r.json();
    throw new Error(`HTTP ${r.status}`);
};

export const SugestoesService = {
    /** A caixinha da modal "Suporte e sugestões". Empresa e pessoa a API tira da sessão. */
    enviar: async (dados: { tipo: TipoSugestao; texto: string; tela?: string }) =>
        ler<null>(await apiFetch(`${API_URL}/api/Sugestoes/Enviar`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dados),
        })),

    listar: async () =>
        ler<SugestaoSistema[]>(await apiFetch(`${API_URL}/api/sistema/sugestoes`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        })),

    marcarLida: async (id: number, lida: boolean) =>
        ler<null>(await apiFetch(`${API_URL}/api/sistema/sugestoes/${id}/lida`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ lida }),
        })),
};
